import React, { useState, useEffect } from 'react';
import moment from 'moment'
import Moment from 'react-moment'
import { dataService } from '../services';

const Tag = (props) => {
    let relDoc = props.relatedDocument;
    let theme = props.theme;
    let icon = props.icon;
    let iconHTML = icon != null ? <i className={icon} /> : [];

    return (
    <div className={"btn btn-xs upcoming-action-tag " + theme} 
        onClick={()=>window.open("form/" + relDoc.documentId, "_self")}>
        {iconHTML} {relDoc.name}
    </div>)
};

const isScheduled = x => !(x.meetingTime === undefined || x.meetingTime === null);

const applyStatus = (status, action, doRefresh) => async () => {
  let diffedAction = { ...action };
  diffedAction.status = status;
    
  if ( diffedAction.meetingTime === undefined || diffedAction.meetingTime === null )
  {
    diffedAction.meetingTime = moment( moment.now() ).toISOString( false );
  }

  /* Historydoc stuff (for crm-history component) */
  let iconFromType = {
    "Call":           "fa-phone",
    "Email":				"fa-envelope",
    "Presentation":           "fa-video",
    "Other":				"fa-question",
  };

  diffedAction.historyDesc = diffedAction.desc;
  diffedAction.historyType = "Action";
  diffedAction.historyIcon = status === "Cancelled" ? "fa fa-ban" : iconFromType[ action.actionType ];
  diffedAction.historyTime = diffedAction.meetingTime;

  diffedAction.historyDocs = [ 
    diffedAction.opportunityRel, 
    diffedAction.organisationRel, 
    diffedAction.contactsRel,
    diffedAction.teamMemberRel
    ].filter( a => a !== undefined ).reduce( (a, b) => a.concat(b), [] );
  diffedAction.historyOpensOverlay = true;
  
  diffedAction.appTags = ['crm', 'actions', 'history'];

  // apply update
  await dataService.deepDiffUpdate( action, diffedAction, ()=>{ } );
  doRefresh();
}

const PinButton = props => {
  let action = props.action;
  //let onActionComplete = applyStatus( "Completed", {... action}, props.doRefresh );

  const updatePin = async () => {
    let diffedAction = {...action};

    if ( diffedAction.pinnedToUpcoming == undefined ) 
      diffedAction.pinnedToUpcoming = false;

    diffedAction.pinnedToUpcoming = !diffedAction.pinnedToUpcoming;
 
    // apply update
    await dataService.deepDiffUpdate( action, diffedAction );
    props.doRefresh();
  };

  let pin = action.pinnedToUpcoming === true ? <i className="fa fa-star" /> : <i className="far fa-star" />;

  return <div className="btn btn-info btn-sm" onClick={updatePin}> {pin} </div>
}

const CompleteButton = props => {
  let action = props.action;
  let onActionComplete = applyStatus( "Completed", {... action}, props.doRefresh );

  return <div className="btn btn-success btn-sm" onClick={onActionComplete}> <i className="fa fa-check" /> </div>
}

const DelayButton = props => {
  let action = props.action;

  const addDelayToDoc = async (time) => {
    let diffedAction = {...action};
    diffedAction.hiddenUntil = time.toISOString( false );
 
    // apply update
    await dataService.deepDiffUpdate( action, diffedAction );
    props.doRefresh();
  };

  const DelayRow = (props) => {
    return <li onClick={ () => addDelayToDoc( Moment.globalMoment().clone().add( props.n, props.t ).startOf('day') ) }> 
      <a>{props.children}</a> 
    </li>
  }

  return [
    <div className="btn btn-warning btn-sm" data-toggle='dropdown'><i className="fa fa-forward" /> <div class="caret"/></div>,
    <ul className="dropdown-menu">
      <DelayRow n={1} t="day">1 Day</DelayRow>
      <DelayRow n={1} t="week">1 Week</DelayRow>
      <DelayRow n={1} t="month">1 Month</DelayRow>
      <DelayRow n={3} t="month">3 Months</DelayRow>
      <DelayRow n={6} t="month">6 Months</DelayRow>
    </ul>
  ]
};

const CancelButton = (props) => {
  let action = props.action;
  let onCancelAction = applyStatus( "Cancelled", {... action}, props.doRefresh );

  return <div className="btn btn-danger btn-sm" onClick={onCancelAction}> <i className="fa fa-ban" /> </div>
}

const UpcomingAction = props => {
    const doRefresh = props.doRefresh;
    const calendarStrings = {
      lastDay : '[Yesterday at] LT',
      sameDay : '[Today at] LT',
      nextDay : '[Tomorrow at] LT',
      lastWeek : '[last] dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'L'
    };
    
    let iconFromTypeMapping = {
      "Phone Call":			      "fa-phone",
      "Skype Call":			      "fa-phone",
      "Zoom Call":			      "fa-phone",
      "Email":				        "fa-envelope",
      "Online Presentation":  "fa-video",
      "Physical Presentation":"fa-video",
      "Other":				        "fa-question",
      "Call":			      "fa-phone",
      "Presentation":   "fa-video",
    };

    let makeTag = (theme, icon=null) => doc => (<Tag relatedDocument={doc} theme={theme} icon={icon} />);

    let action = props.action;
    let title = action.desc;
    let isPast = moment( action.meetingTime ) < moment( moment.now() );
    let time = isScheduled(action) ? [<Moment calendar={calendarStrings} date={action.meetingTime} style={isPast ? { color: "rgb(217, 83, 79)" } : {}} />] : [];
    let teamMembers = action.teamMemberRel ? action.teamMemberRel.map( makeTag("btn-default", "fa fa-user-tie") ) : [];
    let contacts = action.contactsRel ? action.contactsRel.map( makeTag("btn-default", "fa fa-user") ) : [];
    let opportunity = action.opportunityRel ? action.opportunityRel.map( makeTag("btn-default", "fa fa-chart-line") ) : [];
    let organisation = action.organisationRel ? action.organisationRel.map( makeTag("btn-default", "fa fa-building") ) : [];
    let tags = action.tagsRel ? action.tagsRel.map( makeTag("btn-default", "fa fa-tag") ) : [];

    let icon = (<i className={"fa upcoming-action-icon " + iconFromTypeMapping[action.actionType]} />);


    let notes = [];
    if ( action.notes !== undefined && action.notes.length > 0 )
    {
      let notesComponents = [];
      let splitNotes = action.notes.split("\n");
      splitNotes.forEach( x => { notesComponents = notesComponents.concat( [ x, <br/> ] ) } )
  
      if ( notesComponents.length > 10 )
      {
          let total = notesComponents.length  / 2;
          notesComponents = notesComponents.slice(0, 10);
          notesComponents = notesComponents.concat([<b>... {total - 10} More Lines</b>]);
      }
  
      notes = [(
          <div className="col-md-12 well well-sm upcoming-action-notes">
              {notesComponents}
          </div>
      )];
    }

return (<div className="upcoming-action">
    <div className="upcoming-action-title col-md-12" style={{"padding":0}}>
      <div className="col-md-12 col-lg-9" style={{"padding":0}}>
        {icon}
        <a href={"form/" + action.documentId}>{title}</a>
        <div className="upcoming-action-time">
          {time}
        </div>
      </div>
      <div className="col-md-12 col-lg-3 text-right" style={{"padding":0}}>
        {isScheduled(action) ? [] : 
          <DelayButton action={action} doRefresh={doRefresh} />}
        <PinButton action={action} doRefresh={doRefresh} />
        <CompleteButton action={action} doRefresh={doRefresh} />
        <CancelButton action={action} doRefresh={doRefresh} />
      </div>
    </div><br/>

    <div className="upcoming-action-body col-md-12">
      <div className="upcoming-action-tags col-md-8">
        {teamMembers}
        {contacts}
        {opportunity}
        {organisation}
        {tags}
      </div>

      {notes}
    </div>
  </div>);
};

export default UpcomingAction;
